import { TranscriptionContainer } from './transcription/transcription-container';

function Home() {
  return (
    <div className="relative w-full min-h-screen overflow-x-hidden bg-white">
      <div className="max-w-7xl mx-auto px-4 py-8 sm:px-6 sm:py-12">
        <TranscriptionContainer />
      </div>
    </div>
  );
}

export default Home;
